import { getClassNames } from '@ab-core/functions/styles/classNameFormatter';
import { Icon } from '@ab-core/icon';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { FavoriteItemType } from '../list/types';
import { FavoritItemInner } from './styled';

type ItemInnerProps = Pick<FavoriteItemType, 'icon' | 'name'>;

export const ItemInner: FC<ItemInnerProps> = (props) => {
    const { name, icon } = props;
    const favoriteTextClass = getClassNames({
        prefix: 'favorite-item-name'
    });

    return (
        <FavoritItemInner>
            {icon && <Icon name={icon} size="MEDIUM_3" />}
            <Text color="inherit" className={favoriteTextClass} type={FontTypes.Caption}>
                {name}
            </Text>
        </FavoritItemInner>
    );
};
